import React from 'react';
import { Search } from 'lucide-react';

export default function ForumFilters({ filters, setFilters }) {
 const handleChange = (e) => {
 const { name, value } = e.target;
 setFilters(prev => ({ ...prev, [name]: value }));
 };

 const handleTabClick = (statusValue) => {
 setFilters(prev => ({ ...prev, status: statusValue }));
 };

 const tabs = [
 { label: "Tous", value: "" },
 { label: "Nouveaux", value: "NEW" },
 { label: "En analyse", value: "UNDER_ANALYSIS" },
 { label: "En comité", value: "INVESTMENT_COMMITTEE" },
 { label: "Historique", value: "HISTORIQUE" }
 ];

 return (
 <div className="overflow-hidden flex flex-col md:flex-row md:items-center md:justify-between px-6 border-b border-workspace">
 {/* 🔹 Navigation par onglets (Tabs) */}
 <nav className="flex space-x-8 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]" aria-label="Tabs">
 {tabs.map((tab) => (
 <button
 key={tab.value}
 onClick={() => handleTabClick(tab.value)}
 className={`
 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
 ${(filters.status || "") === tab.value
 ? "border-secondary text-secondary"
 : "border-transparent text-tertiary hover:text-primary hover:border-workspace"
 }
 `}
 >
 {tab.label}
 </button>
 ))}
 </nav>

 {/* 🔹 Barre de recherche */}
 <div className="py-3 md:py-0 relative group flex-shrink-0 transition-all duration-300 w-full md:w-64 focus-within:md:w-80">
 <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
 <Search className="w-4 h-4 text-tertiary group-focus-within:text-primary transition-colors duration-300" />
 </div>
 <input 
 type="text" 
 name="search" 
 placeholder="Rechercher un dossier..." 
 value={filters.search || ''} 
 onChange={handleChange}
 className="w-full bg-surface hover:bg-surface-muted focus:bg-surface text-sm border border-workspace rounded-full pl-10 pr-4 py-2 text-primary placeholder-tertiary shadow-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-300"
 />
 </div>
 </div>
 );
}
